// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Box } from '../../../lib/base';

export default function DateRangeContainer({
  startDateFilterMenu,
  endDateFilterMenu,
}: {
  readonly startDateFilterMenu: React.ReactNode;
  readonly endDateFilterMenu: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        flexWrap: 'wrap',
        gap: 1,
        alignItems: 'center',
      }}
    >
      {startDateFilterMenu}
      <Box sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
        <span>-</span>
      </Box>
      {endDateFilterMenu}
    </Box>
  );
}
